import {createLazyFileRoute} from '@tanstack/react-router'

import Orders from '@/views/Account/Orders/Orders'

export const Route = createLazyFileRoute('/_account/orders/')({
  component: Orders,
})
